// App utils
import { datajs } from '../shared/utils';

(function() {
	const toggleSiteNav = () => {
		document.body.classList.toggle('has-menu');
		return false;
	};

	const closeSiteNav = () => {
		document.body.classList.remove('has-menu');
	};

	const handleDocumentKeyUp = e => {
		// Close menu using Esc key.
		if (e.keyCode === 27) {
			closeSiteNav();
		}
	};

	const offCanvasNav = () => {
		datajs('off-canvas-toggle').forEach(item => item.addEventListener('click', toggleSiteNav));

		// Handle document keyup event
		document.addEventListener('keyup', handleDocumentKeyUp);
	};

	document.addEventListener('DOMContentLoaded', offCanvasNav);
})();
